import { CommonErrorCode, UserErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { Module } from '../Module';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { ToasterService, ToastType } from './ToasterService';

// Notification For:
// => update display name for a single user

export class UpdateUserDisplayNameNotification {

  public static $inject = [
    '$translate',
    'ToasterService'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService) {}

  public notify(
    result: IResult,
    username: string,
    displayName: string) {

    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = this.errorMessageFor(result.errors[0], username);
      this.toaster.pop({ type: ToastType.Error, text: errorMsg });
    } else {
      const successMsg = this.$translate.instant('updateUserDisplayNameSuccess', { USER_NAME: L10n.elideIfLong(username), DISPLAY_NAME: L10n.elideIfLong(displayName) });
      this.toaster.pop({ type: ToastType.Info, text: successMsg});
    }
  }

  private errorMessageFor(error: IError, username: string) {
    switch (error.code) {
      case CommonErrorCode.SystemUserNotFound:
        return this.$translate.instant('errorSystemUserNotFound', { USER_NAME: L10n.elideIfLong(username) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('UpdateUserDisplayNameNotification', UpdateUserDisplayNameNotification);

// Notification For:
// => update display name for a single user

export class UpdateUserEmailNotification {

  public static $inject = [
    '$translate',
    'ToasterService'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService) {}

  public notify(
    result: IResult,
    username: string,
    email: string) {

    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = this.errorMessageFor(result.errors[0], username);
      this.toaster.pop({ type: ToastType.Error, text: errorMsg});
    } else {
      const successMsg = this.$translate.instant('updateUserEmailSuccess', { USER_NAME: L10n.elideIfLong(username), EMAIL: email });
      this.toaster.pop({ type: ToastType.Info, text: successMsg});
    }
  }

  private errorMessageFor(error: IError, username: string) {
    switch (error.code) {
      case CommonErrorCode.SystemUserNotFound:
        return this.$translate.instant('errorSystemUserNotFound', { USER_NAME: L10n.elideIfLong(username) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('UpdateUserEmailNotification', UpdateUserEmailNotification);


// Notification For:
// => synchronize a single AD user (uses importUsersFromAD API)

export class SyncUserActionNotification {

  public static $inject = [
    '$translate',
    'ToasterService'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService) {}

  public notify(
    result: IResult,
    username: string) {

    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = this.errorMessageFor(result.errors[0], username);
      this.toaster.pop({ type: ToastType.Error, text: errorMsg});
    } else {
      const successMsg = this.$translate.instant('syncUserSuccess', { USER_NAME: L10n.elideIfLong(username) });
      this.toaster.pop({ type: ToastType.Info, text: successMsg});
    }
  }

  private errorMessageFor(error: IError, username: string) {
    switch (error.code) {
      case CommonErrorCode.SystemUserNotFound:
        return this.$translate.instant('errorSystemUserNotFound', { USER_NAME: L10n.elideIfLong(username) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('SyncUserActionNotification', SyncUserActionNotification);


// Notification For:
// => changing password of a user

export class ChangePasswordNotification {

  public static $inject = [
    '$translate',
    'ToasterService'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService) {}

  public notify(
    result: IResult,
    username: string) {

    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = this.errorMessageFor(result.errors[0], username);
      this.toaster.pop({ type: ToastType.Error, text: errorMsg});
    } else {
      const successMsg = this.$translate.instant('changePasswordSuccess', { USER_NAME: L10n.elideIfLong(username) });
      this.toaster.pop({ type: ToastType.Info, text: successMsg});
    }
  }

  private errorMessageFor(error: IError, username: string) {
    switch (error.code) {
      case CommonErrorCode.SystemUserNotFound:
        return this.$translate.instant('errorSystemUserNotFound', { USER_NAME: L10n.elideIfLong(username) });
      case UserErrorCode.UserInvalidPassword:
        return this.$translate.instant('errorUserOldPasswordIncorrect');
      case UserErrorCode.UserPasswordNotRespectingPolicies:
        return this.$translate.instant('errorUserPasswordNotRespectingPolicies');
      case UserErrorCode.LoginAttemptRejected:
        return this.$translate.instant('errorAccountIsInLockoutPeriod');
      case UserErrorCode.PasswordNotUpdated:
        return this.$translate.instant('newPasswordIsSameAsOldPasswordError');
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('ChangePasswordNotification', ChangePasswordNotification);

export class ChangeLanguageNotification {
  public static $inject = [ '$translate', 'ToasterService' ];
  constructor(
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService) {}
  public notify(
    result: IResult,
    username: string) {
    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = this.errorMessageFor(result.errors[0], username);
      this.toaster.pop({ type: ToastType.Error, text: errorMsg});
    } else {
      const successMsg = this.$translate.instant('changeLanguageSuccess', { USER_NAME: L10n.elideIfLong(username) });
      this.toaster.pop({ type: ToastType.Info, text: successMsg});
    }
  }

  private errorMessageFor(error: IError, username: string) {
    switch (error.code) {
      case CommonErrorCode.SystemUserNotFound:
        return this.$translate.instant('errorSystemUserNotFound', { USER_NAME: L10n.elideIfLong(username) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('ChangeLanguageNotification', ChangeLanguageNotification);

export class ChangeLocaleNotification {

  public static $inject = [ '$translate', 'ToasterService' ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService) {}

  public notify(
    result: IResult,
    username: string) {
    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = this.errorMessageFor(result.errors[0], username);
      this.toaster.pop({ type: ToastType.Error, text: errorMsg});
    } else {
      const successMsg = this.$translate.instant('changeLocaleSuccess', { USER_NAME: L10n.elideIfLong(username) });
      this.toaster.pop({ type: ToastType.Info, text: successMsg});
    }
  }

  private errorMessageFor(error: IError, username: string) {
    switch (error.code) {
      case CommonErrorCode.SystemUserNotFound:
        return this.$translate.instant('errorSystemUserNotFound', { USER_NAME: L10n.elideIfLong(username) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('ChangeLocaleNotification', ChangeLocaleNotification);

export class ChangeTimeZoneNotification {

  public static $inject = [ '$translate', 'ToasterService' ];

  constructor(
      private $translate: ng.translate.ITranslateService,
      private toaster: ToasterService) {}

  public notify(
      result: IResult,
      username: string) {
    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = this.errorMessageFor(result.errors[0], username);
      this.toaster.pop({ type: ToastType.Error, text: errorMsg});
    } else {
      const successMsg = this.$translate.instant('changeTimeZoneSuccess', { USER_NAME: L10n.elideIfLong(username) });
      this.toaster.pop({ type: ToastType.Info, text: successMsg});
    }
  }

  private errorMessageFor(error: IError, username: string) {
    switch (error.code) {
      case CommonErrorCode.SystemUserNotFound:
        return this.$translate.instant('errorSystemUserNotFound', { USER_NAME: L10n.elideIfLong(username) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('ChangeTimeZoneNotification', ChangeTimeZoneNotification);
